(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  ;(() => {
    const sections = document.querySelectorAll('.product-recommendations')
    if (!sections.length) return

    const wire = section => {
      if ('static' in section.dataset) return
      const loadRecommendations = () => {
        const { url, productId } = section.dataset

        if (!productId || productId === 'undefined' || productId === '') {
          section.style.display = 'none'
          return
        }

        fetch(url)
          .then(response => (response.ok ? response.text() : Promise.reject()))
          .then(text => {
            const temp = document.createElement('div')
            temp.innerHTML = text
            const newContent = temp.querySelector('.product-recommendations')

            if (newContent && newContent.innerHTML.trim()) {
              const newSlides = newContent.querySelectorAll('.carousel-slide')
              if (!newSlides.length) {
                section.style.display = 'none'
                return
              }
              const slideContainer = section.querySelector('[ref="container"]')
              const newSlideContainer = newContent.querySelector('[ref="container"]')
              if (slideContainer && newSlideContainer) {
                slideContainer.replaceChildren(...newSlideContainer.childNodes)
              } else {
                section.innerHTML = newContent.innerHTML
              }
              const title = section.querySelector('h2')
              const newTitle = newContent.querySelector('h2')
              if (title && newTitle) title.textContent = newTitle.textContent
            }
          })
          .catch(() => (section.style.display = 'none'))
      }

      const handleIntersection = (entries, observer) => {
        if (entries[0].isIntersecting) {
          observer.unobserve(section)
          loadRecommendations()
        }
      }

      const rect = section.getBoundingClientRect()
      const isVisible = rect.top < window.innerHeight && rect.bottom > 0

      if (isVisible) {
        loadRecommendations()
      } else {
        new IntersectionObserver(handleIntersection, {
          rootMargin: '0px 0px 200px 0px',
          threshold: 0.1
        }).observe(section)
      }
    }

    sections.forEach(wire)
  })()

  } catch(e) { console.error(e); }
})();
})();
